import { useState } from 'react';
import { X } from 'lucide-react';
import { APP_VERSION, CHANGELOG } from '../lib/version';

export function VersionBadge() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed hidden md:block bottom-3 right-3 z-40 rounded-full bg-white/80 backdrop-blur-sm border border-gray-200 px-2.5 py-1 text-xs text-gray-500 shadow-sm hover:bg-white hover:text-gray-700 hover:shadow-md transition-all"
        aria-label="View release notes"
      >
        v{APP_VERSION}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-end justify-end p-4 sm:items-center sm:justify-center"
          onClick={() => setOpen(false)}
        >
          <div className="absolute inset-0 bg-black/30" aria-hidden="true" />
          <div
            className="relative z-10 w-full max-w-md max-h-[80vh] flex flex-col rounded-xl bg-white shadow-xl border border-gray-200"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
              <h2 className="text-sm font-semibold text-gray-800">What's new</h2>
              <button
                onClick={() => setOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
                aria-label="Close"
              >
                <X size={16} />
              </button>
            </div>
            <div className="overflow-y-auto px-5 py-4 space-y-6">
              {CHANGELOG.map((entry) => (
                <div key={entry.version}>
                  <div className="flex items-baseline gap-2 mb-1">
                    <span className="text-xs font-mono font-semibold text-indigo-600">
                      v{entry.version}
                    </span>
                    <span className="text-xs text-gray-400">{entry.date}</span>
                  </div>
                  <p className="text-sm font-medium text-gray-800 mb-2">{entry.title}</p>
                  <ul className="space-y-1">
                    {entry.changes.map((change, i) => (
                      <li key={i} className="text-xs text-gray-600 flex gap-2">
                        <span className="mt-1 shrink-0 w-1 h-1 rounded-full bg-gray-400" />
                        <span>{change}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
